import { useEffect, useCallback, useMemo, useState } from 'react';
import { routeHistory } from '@nackle/biw-web-router';
import { get } from 'lodash';


export const useParam = ( paramName ) => {

    const [ didCheck, setChecked ] = useState( false );
    const [ routeData, setRouteData ] = useState();
    const [ addedListener, setAddedListener ] = useState( false );
   
    /**
     * Handles updates to the route/site navigation. Stores the route data whenever
     * a new route has been navigated to.
     */
    const handleRouteChanged = useCallback( ( action, nextRoute, prevRoute ) => {
        setRouteData( nextRoute );

        if ( !didCheck ) {
            setChecked( true );
        }
    }, [ setRouteData, didCheck, setChecked ] );

    
    useEffect( () => {
        // Trigger a quick refresh of the router so that this hook catches the new (current)
        // route the user is on.
        routeHistory.refresh();
        
        if ( !addedListener ) {
            setAddedListener( true );
            routeHistory.addEventListener( 'changed', handleRouteChanged );
        } 
        
        return () => {
            routeHistory.removeEventListener( 'changed', handleRouteChanged );
        };
    }, [ handleRouteChanged ] );

    /**
     * The value of the desired parameter pulled from the current route details if
     * available.
     */
    const paramValue = useMemo( () => {
        return get( routeData?.state?.params, paramName );
    }, [ paramName, routeData ] );

    return useMemo( () => {
        return { value: paramValue, checked: didCheck };
    }, [ paramValue, didCheck ] );
};
